import React from "react";

const Privacy = () => {
  return (
    <div className="min-h-screen bg-gray-50/50 pb-20">
      {/* ================= PREMIUM CATEGORY BANNER ================= */}
      <div className="bg-gradient-to-br from-[#2d006b] to-[#4600a3] text-white py-6 md:py-8 mb-6 relative overflow-hidden shadow-inner">
        {/* Subtle Background Patterns */}
        <div className="absolute inset-0 opacity-10 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMiIgY3k9IjIiIHI9IjEiIGZpbGw9InJnYmEoMCwwLDAsMC4wNSkiLz48L3N2Zz4=')]" />
        <div className="absolute top-0 right-0 w-96 h-96 bg-white opacity-10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3 animate-pulse" />
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-brand-red opacity-10 rounded-full blur-2xl translate-y-1/3 -translate-x-1/4" />
        
        <div className="max-w-7xl mx-auto px-4 relative z-10 flex flex-col items-center text-center">
          <span className="text-purple-200 text-xs md:text-sm font-bold tracking-[0.2em] uppercase mb-1">आपकी डेटा सुरक्षा</span>
          <h1 className="text-2xl md:text-4xl lg:text-5xl font-black capitalize tracking-tight mb-3 drop-shadow-md">
             गोपनीयता नीति
          </h1>
          <div className="w-12 h-1 bg-gradient-to-r from-purple-200 to-white rounded-full opacity-90 shadow-[0_0_15px_rgba(255,255,255,0.5)]" />
        </div>
      </div>

      {/* CONTENT */}
      <div className="max-w-4xl mx-auto px-4 py-10">
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 md:p-12 text-gray-700 leading-relaxed space-y-8">
          
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">1. हम कौन सी जानकारी एकत्र करते हैं</h2>
            <p>
              मंदाकिनी टाइम्स में, हम अपने उपयोगकर्ताओं को बेहतर सेवाएं प्रदान करने के लिए जानकारी एकत्र करते हैं। इसमें आपका आईपी एड्रेस, ब्राउज़र का प्रकार और हमारी समाचार सामग्री के साथ आपकी बातचीत जैसी बुनियादी जानकारी शामिल है। यदि आप स्वेच्छा से न्यूज़लेटर की सदस्यता लेते समय या संपर्क फ़ॉर्म जमा करते समय व्यक्तिगत जानकारी प्रदान करते हैं, तो हम उसे भी एकत्र कर सकते हैं।
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">2. हम आपकी जानकारी का उपयोग कैसे करते हैं</h2>
            <p>
              हम एकत्र किए गए डेटा का उपयोग अपने दर्शकों को समझने, अपनी पत्रकारिता और रिपोर्टिंग में सुधार करने और हमारे पोर्टल पर आपके अनुभव को व्यक्तिगत बनाने के लिए करते हैं। हम आपकी व्यक्तिगत जानकारी तीसरे पक्षों को नहीं बेचते या किराए पर नहीं देते हैं। हम न्यूज़ अपडेट भेजने या आपकी पूछताछ का जवाब देने के लिए आपके ईमेल का उपयोग कर सकते हैं।
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">3. कुकीज़ और ट्रैकिंग</h2>
            <p>
              उपयोगकर्ता अनुभव को बढ़ाने और वेबसाइट एनालिटिक्स को ट्रैक करने के लिए हमारी वेबसाइट "कुकीज़" का उपयोग करती है। कुकीज़ छोटी डेटा फ़ाइलें होती हैं जो आपकी हार्ड ड्राइव पर संग्रहीत होती हैं। आप अपने वेब ब्राउज़र को कुकीज़ को अस्वीकार करने, या कुकीज़ भेजे जाने पर आपको सचेत करने के लिए सेट करना चुन सकते हैं, लेकिन इसके परिणामस्वरूप साइट के कुछ हिस्से ठीक से काम नहीं कर सकते हैं।
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">4. तृतीय-पक्ष विज्ञापन</h2>
            <p>
              जब आप हमारी वेबसाइट पर जाते हैं तो हम विज्ञापन देने के लिए तृतीय-पक्ष विज्ञापन कंपनियों का उपयोग कर सकते हैं। ये कंपनियाँ आपकी रुचि की वस्तुओं और सेवाओं के बारे में विज्ञापन प्रदान करने के लिए इस और अन्य वेबसाइटों पर आपकी विज़िट के बारे में एकत्रित जानकारी (जिसमें आपका नाम, पता, ईमेल पता या टेलीफ़ोन नंबर शामिल नहीं है) का उपयोग कर सकती हैं।
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">5. डेटा सुरक्षा</h2>
            <p>
              हम अनधिकृत पहुँच, परिवर्तन, प्रकटीकरण, या आपकी व्यक्तिगत जानकारी और हमारी साइट पर संग्रहीत डेटा के विनाश से बचाने के लिए उचित डेटा संग्रह, भंडारण और प्रसंस्करण प्रथाओं और सुरक्षा उपायों को अपनाते हैं।
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">6. इस गोपनीयता नीति में परिवर्तन</h2>
            <p>
              मंदाकिनी टाइम्स के पास इस गोपनीयता नीति को किसी भी समय अपडेट करने का विवेक है। जब हम ऐसा करेंगे, तो हम इस पृष्ठ के निचले भाग में अद्यतन तिथि को संशोधित करेंगे। हम उपयोगकर्ताओं को यह जानने के लिए इस पृष्ठ को बार-बार जाँचने के लिए प्रोत्साहित करते हैं कि हम एकत्रित व्यक्तिगत जानकारी की सुरक्षा में कैसे मदद कर रहे हैं।
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">7. हमसे संपर्क करें</h2>
            <p>
              यदि इस गोपनीयता नीति, इस साइट की प्रथाओं, या इस साइट के साथ आपके व्यवहार के बारे में आपके कोई प्रश्न हैं, तो कृपया हमसे संपर्क करें:
            </p>
            <ul className="mt-2 list-disc list-inside text-purple-600 font-medium">
              <li>Email: info@mandakinitimes.com</li>
              <li>Phone: +91 97557 24915</li>
            </ul>
          </section>
          
        </div>
      </div>
    </div>
  );
};

export default Privacy;
